import { render, staticRenderFns } from "./MotorTransactionsGIA.vue?vue&type=template&id=325b7a56&"
import script from "./MotorTransactionsGIA.vue?vue&type=script&lang=js&"
export * from "./MotorTransactionsGIA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports